export const getCookie = (cname) => {
  var data = "";
  var name = cname + "=";
  var decodedCookie = decodeURIComponent(document.cookie);
  var ca = decodedCookie.split(";");
  for (var i = 0; i < ca.length; i++) {
    var c = ca[i];
    while (c.charAt(0) === " ") {
      c = c.substring(1);
    }
    if (c.indexOf(name) === 0) {
      data = c.substring(name.length, c.length);
      if (data !== "") {
        return data;
      }
    }
  }
  return "";
};

export const setCookie = (name, value) => {
  document.cookie = `${name}=${encodeURIComponent(value)}; path=/;`;
};

export default getCookie;